import { RangePicker } from '@pages'
import { Skeleton } from 'antd'
import { t } from 'i18next'
import moment from 'moment'
import { Button, Input, SharedTable } from 'src/common'
import { SearchIcon } from 'src/components/Icon'
import ConfirmDeleteModal from 'src/components/staff-and-role-management/ConfirmDeleteModal'
import styled from 'styled-components'
import { useListCvTable } from './useListCvTable'
import { ViewDetailCV } from './ViewDetailCV'

interface IProps {
  onAddNew: () => void
}
const ListCV = ({ onAddNew }: IProps) => {
  const {
    applications,
    columns,
    searchString,
    setSearchString,
    totalApplication,
    getListApplication,
    currentPage,
    isGettingApplication,
    setDateSelect,
    handleClear,
    deleteId,
    setDeleteId,
    isDeleting,
    onDeleteApplication,
    applicationItem,
    dateSelect,
    setApplicationItem,
  } = useListCvTable()
  return (
    <>
      <>
        <div className="flex items-center justify-between py-[1.25rem] w-full">
          <div className="flex items-center gap-x-2 w-fit">
            <Input
              className="pl-5 !h-[38px] "
              value={searchString}
              onChange={(e) => setSearchString(e.target.value)}
              containerClassName="min-w-[350px]"
              placeholder={t('evolveLanding:search_job')}
              prefix={<SearchIcon className="pl-2" />}
            />
            <DateRangePicker
              onChange={(data) => {
                if (data) {
                  setDateSelect({
                    startDate: moment(data[0]).format('YYYY-MM-DD'),
                    endDate: moment(data[1]).format('YYYY-MM-DD'),
                  })
                }
              }}
              value={
                dateSelect?.startDate && dateSelect.endDate
                  ? [moment(dateSelect?.startDate), moment(dateSelect?.endDate)]
                  : undefined
              }
              className="!min-w-[245px] !rounded-[5px] !h-[38px] !border-slate-200"
            />
          </div>
          <div className="flex gap-x-2">
            <Button
              htmlType="submit"
              type="primary"
              size="middle"
              className="!bg-red-500 !border-none h-10"
              style={{
                alignSelf: 'flex-end',
              }}
              onClick={handleClear}
            >
              {'Clear filter'}
            </Button>
            {/* <Button
              htmlType="submit"
              type="primary"
              size="middle"
              className="submit__btn loginselected-btn"
              icon={<PlusOutlined className="!text-[16px]" />}
              style={{
                alignSelf: 'flex-end',
              }}
              onClick={() => {
                onAddNew()
              }}
            >
              {'Export'}
            </Button> */}
          </div>
        </div>
        {isGettingApplication ? (
          <Skeleton
            paragraph={{ rows: 4 }}
            style={{
              marginTop: 10,
            }}
            className=" !w-[95vw] 2xl:!w-[1400px]"
          />
        ) : (
          <SharedTable
            rowKey="key"
            className="lg:!max-h-[60vh]"
            columns={columns}
            dataSource={applications?.map((item: any, index: any) => {
              return {
                ...item,
                key: item?.id,
              }
            })}
            paginationProps={{
              total: !!totalApplication ? +totalApplication : undefined,
              pageSize: 10,
              current: currentPage || 1,
              onChange(page) {
                const params: { page: number } = {
                  page: page,
                }
                getListApplication(params)
              },
            }}
            sticky
          />
        )}
        <ViewDetailCV
          open={applicationItem ? true : false}
          item={applicationItem as any}
          onClose={() => setApplicationItem(null)}
        />
        <ConfirmDeleteModal
          title="Delete this application"
          content="Are you sure to delete this application?"
          open={Boolean(deleteId)}
          onClose={() => setDeleteId('')}
          isLoading={isDeleting || false}
          onDelete={onDeleteApplication}
        />
      </>
    </>
  )
}

export default ListCV

const DateRangePicker = styled(RangePicker)`
  &.ant-picker-focused,
  &:focus {
    border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
    --tw-border-opacity: 0.4;
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
      var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
      calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
      var(--tw-shadow, 0 0 #0000);
    --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
    --tw-ring-opacity: 0.2;
  }
`
